import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

/**
 * Loading State Component
 * Displays a loading indicator while fetching applications
 */
export const LoadingState = React.memo(() => (
  <div className="min-h-screen bg-background-primary p-6">
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <span className="ml-3 text-text-secondary">Loading your applications...</span>
      </div>
    </div>
  </div>
));

/**
 * Error State Component
 * Displays error message with retry option
 */
export const ErrorState = React.memo(({ error, onRetry }) => (
  <div className="min-h-screen bg-background-primary p-6">
    <div className="max-w-6xl mx-auto">
      <div className="text-center py-12">
        <Icon name="AlertCircle" size={48} className="text-error mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-text-primary mb-2">Error Loading Applications</h3>
        <p className="text-text-secondary mb-4">{error}</p>
        <Button onClick={onRetry} variant="primary">
          Try Again
        </Button>
      </div>
    </div>
  </div>
));

/**
 * Empty State Component
 * Displays message when no applications exist or match filters
 */
export const EmptyState = React.memo(({ hasApplications, onBrowseJobs }) => (
  <div className="bg-white rounded-lg shadow-sm border border-border-primary p-8 text-center">
    <Icon name="FileText" size={48} className="text-text-muted mx-auto mb-4" />
    <h3 className="text-lg font-semibold text-text-primary mb-2">
      {!hasApplications ? 'No Applications Yet' : 'No Applications Found'}
    </h3>
    <p className="text-text-secondary mb-4">
      {!hasApplications 
        ? 'Start applying to jobs to see your applications here.'
        : 'Try adjusting your search criteria to find more applications.'
      }
    </p>
    {!hasApplications && (
      <Button onClick={onBrowseJobs} variant="primary">
        Browse Jobs
      </Button>
    )}
  </div>
));
